<app-example-wrapper-seamless sectionHeading="Profile" *ngIf="profileData!=null">
    <div class="card card-box p-4">
        <div class="d-flex align-items-center mb-3">
            <div class="avatar-icon-wrapper avatar-initials avatar-icon-lg mr-3">
                <div class="avatar-icon text-white bg-primary">
                    {{letters}}
                </div>
            </div>
            <div class="w-100">
                <a [routerLink]="" class="font-weight-bold font-size-lg" title="...">{{profileData.firstname}}
                    {{profileData.lastname}}</a>
                <span class="text-black-50 d-block" *ngIf="profileData.access_level==1">{{profileData.email}}</span>
                <span class="text-black-50 d-block" *ngIf="profileData.access_level==2">Station Manager, Airport
                    Butler.</span>

            </div>
        </div>


        <form [formGroup]="profile_form" *ngIf="profileData.access_level==2">
            <div class="row">
                <div class="col-md-4 col-sm-6">
                    <div class="position-relative form-group"><label for="exampleEmail">Employee
                            Id</label><input class="form-control" formControlName="empid" placeholder="Employee ID"
                            type="text">
                    </div>

                    <div class="position-relative form-group"><label for="exampleEmail">First Name
                        </label><input class="form-control" id="exampleEmail" formControlName="firstname"
                            placeholder="with a placeholder" type="text">
                    </div>
                    <div class="position-relative form-group"><label for="exampleEmail">Email
                        </label><input class="form-control" formControlName="email" placeholder="Email" type="email">
                    </div>


                    <div class="position-relative form-group"><label for="exampleText">ADDRESS</label><textarea
                            class="form-control" id="exampleText" formControlName="address"></textarea>
                    </div>

                </div>
                <div class="col-md-4 col-sm-6">
                    <div class="position-relative form-group"><label for="exampleEmail">Mobile
                            No</label><input class="form-control" id="exampleEmail" formControlName="mobile"
                            placeholder="Mobile number" type="text">
                    </div>
                    <div class="position-relative form-group"><label for="examplePassword">Last
                            Name</label><input class="form-control" id="examplePassword" formControlName="lastname"
                            placeholder="password placeholder" type="text"></div>
                    <div *ngIf="profileData.language" class="position-relative form-group"><label
                            for="exampleSelect">languages</label>
                        <ng-select [multiple]="true" placeholder="Select languages" formControlName="languages"
                            [(ngModel)]="selectedLanguageids">
                            <ng-option *ngFor="let language of profileData.language" [value]="language.languageId">
                                {{language.description}} </ng-option>
                        </ng-select>
                    </div>
                    <div class="position-relative form-group"><label for="examplePassword">Password</label><input
                            class="form-control" id="examplePassword" formControlName="password"
                            placeholder="password placeholder" type="password"></div>

                </div>
                <div class="col-md-4 col-sm-6">

                    <div class="position-relative form-group"><label for="exampleEmail">Job Type
                        </label><input class="form-control" id="exampleEmail" formControlName="jobtype"
                            placeholder="Job type" type="text">
                    </div>
                    <div class="position-relative form-group"><label for="exampleEmail">Role
                        </label><input class="form-control" formControlName="role" placeholder="Role" type="text">
                    </div>
                    <div class="position-relative form-group" *ngIf="isStationManager">
                        <label for="exampleEmail">Station
                        </label>
                        <ng-select class="disable-text" [multiple]="true" formControlName="stations"
                            [(ngModel)]="selectedStations" placeholder="Select Station">
                            <ng-option *ngFor="let station of profileData.stations" [value]="station.id">
                                {{station.stationid}} - {{station.airportName}}
                            </ng-option>
                        </ng-select>
                    </div>


                </div>
            </div>
        </form>
    </div>
</app-example-wrapper-seamless>

<app-example-wrapper-seamless sectionHeading="Super Admins"  *ngIf="profileData && profileData.access_level==1">
    <div class="row">
        <div class="col-xl-12 col-md-12 col-sm-12">
            <div class="card card-box">
                <div class="card-body">
                    <div class="d-flex justify-content-between pb-3">
                        <div class="search-wrapper">
                            <span class="icon-wrapper text-black">
                                <fa-icon [icon]="['fas', 'search']"></fa-icon>
                            </span>
                            <input type="text" class="form-control form-control-sm rounded-pill" placeholder="Search..."
                                [ngModelOptions]="{standalone: true}" [(ngModel)]="searchText">
                        </div>
                        <div>
                            <button class="btn btn-sm btn-primary" type="button" (click)="addAdmin()"
                                id="addTeamMember">
                                <span class="btn-wrapper--icon">
                                    <fa-icon [icon]="['fas', 'plus']" class="opacity-8 font-size-xs" class="text-white">
                                    </fa-icon>
                                </span>
                                <span class="btn-wrapper--label">
                                    Add Admin
                                </span>
                            </button>
                            <button (click)="getUsers()" tooltip="Refresh" id="reloadEmployees"
                                class="btn d-32 p-0 btn-animated-icon btn-animated-icon--primary btn-neutral-primary ml-2"
                                type="button">
                                <span class="btn-wrapper--icon">
                                    <i class="ion-md-sync"></i>
                                </span>
                            </button>
                        </div>
                    </div>
                    <div *ngIf="superAdmins | tsearch:searchText; let filteredEmployees">
                        <div class="table-responsive">
                            <table class="table table-hover table-striped table-bordered text-nowrap mb-3"
                                [mfData]="filteredEmployees" #mf="mfDataTable" [mfRowsOnPage]="10"
                                [mfActivePage]="activePage">
                                <thead>
                                    <tr>
                                        <th class="bg-white">
                                            <mfDefaultSorter by="firstname">Name</mfDefaultSorter>
                                        </th>
                                        <th class="bg-white text-left">
                                            <mfDefaultSorter by="email">Email</mfDefaultSorter>
                                        </th>
                                        <th class="bg-white text-left">
                                            <mfDefaultSorter by="status">Status</mfDefaultSorter>
                                        </th>
                                        <th class="bg-white text-left">
                                            <mfDefaultSorter by="status">Edit</mfDefaultSorter>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let employee of mf.data ; let i=index">
                                        <td class="text-left">
                                            {{employee.firstname}} {{employee.lastname}}
                                        </td>
                                        <td class="text-left ">
                                            {{employee.email}} </td>
                                        <td class="text-left ">
                                            <span class="badge bg-neutral-dark text-success"
                                                *ngIf="employee.status==true">Active</span>
                                            <span class="badge bg-neutral-dark text-warning"
                                                *ngIf="employee.status==false">Inactive</span>
                                        </td>
                                        <td class="text-left">
                                            <button class="btn btn-sm btn-neutral-dark" tooltip="Edit" type="button"
                                                (click)="editEmployee(employee)">
                                                <fa-icon [icon]="['fas', 'arrow-right']"></fa-icon>
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <td colspan="9">
                                            <span class="font-weight-bold text-primary">Total Super Admin Members:
                                                {{filteredEmployees.length}}</span>
                                            <!--   &nbsp;&nbsp;&nbsp; <span class="font-weight-bold text-success">Active :
                                                {{calculateActiveEmployees(filteredEmployees)}}</span>
                                            &nbsp;&nbsp;&nbsp;
                                            <span class="font-weight-bold text-warning">Inactive :
                                                {{calculateInActiveEmployees(filteredEmployees)}}</span>
                                            &nbsp;&nbsp;&nbsp; -->
                                            <mfBootstrapPaginator [rowsOnPageSet]="[10,30,50,100]">
                                            </mfBootstrapPaginator>
                                        </td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</app-example-wrapper-seamless>


<app-example-wrapper-seamless sectionHeading="Change Password">
    <div class="card card-box p-4">
        <!-- <form [formGroup]="form" (ngSubmit)="submit(form.value)">
            <formly-form [model]="model" [fields]="fields" [options]="options" [form]="form"></formly-form>
            <button type="submit" class="btn btn-primary submit-button">Submit</button>
        </form> -->
        <form [formGroup]="change_password_form">
            <div class="col-md-12 col-sm-12">
                <div class=" form-group">
                    <label for="examplePassword">Old Password *</label>
                    <div class="input-group">
                        <input class="form-control" [type]="!oldPasswordHide ? 'password' : 'text'"
                            formControlName="oldpassword" placeholder="Enter current password" required
                            [ngClass]="{'is-invalid': submitted && f.oldpassword.errors}">
                        <div class="input-group-append">
                            <span class="input-group-text" style="padding: 0rem 1rem !important;">
                                <mat-icon class="placeholder" *ngIf="oldPasswordHide" tooltip="Hide password"
                                    (click)="oldPasswordHide = !oldPasswordHide">
                                    {{'visibility_off'}}
                                </mat-icon>
                                <mat-icon class="placeholder" *ngIf="!oldPasswordHide" tooltip="Show password"
                                    (click)="oldPasswordHide = !oldPasswordHide">
                                    {{ 'visibility'}}
                                </mat-icon>
                            </span>
                        </div>
                    </div>
                    <div *ngFor="let validation of validation_messages.oldpassword">
                        <div class="error-message"
                            *ngIf="f.oldpassword.hasError(validation.type) &&  ((f.oldpassword.dirty || f.oldpassword.touched))">
                            {{validation.message }}
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-md-12 col-sm-12">
                <div class=" form-group">
                    <label for="examplePassword">New Password *</label>
                    <div class="input-group">
                        <input class="form-control" [type]="!newPasswordHide ? 'password' : 'text'"
                            formControlName="newpassword" placeholder="Must be at least 6 characters" required
                            [ngClass]="{'is-invalid': submitted && f.newpassword.errors}">
                        <div class="input-group-append">
                            <span class="input-group-text" style="padding: 0rem 1rem !important;">
                                <mat-icon class="placeholder" *ngIf="newPasswordHide" tooltip="Hide password"
                                    (click)="newPasswordHide = !newPasswordHide">
                                    {{'visibility_off'}}
                                </mat-icon>
                                <mat-icon class="placeholder" *ngIf="!newPasswordHide" tooltip="Show password"
                                    (click)="newPasswordHide = !newPasswordHide">
                                    {{ 'visibility'}}
                                </mat-icon>
                            </span>
                        </div>
                    </div>
                    <div *ngFor="let validation of validation_messages.newpassword">
                        <div class="error-message"
                            *ngIf="f.newpassword.hasError(validation.type) &&  ((f.newpassword.dirty || f.newpassword.touched))">
                            {{validation.message }}
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-md-12 col-sm-12">
                <div class=" form-group">
                    <label for="examplePassword">Confirm Password *</label>
                    <div class="input-group">
                        <input class="form-control" [type]="!confirmPasswordHide ? 'password' : 'text'"
                            formControlName="confirmpassword" placeholder="Please re-enter your password" required
                            [ngClass]="{'is-invalid': submitted && f.confirmpassword.errors}">
                        <div class="input-group-append">
                            <span class="input-group-text" style="padding: 0rem 1rem !important;">
                                <mat-icon class="placeholder" *ngIf="confirmPasswordHide" tooltip="Hide password"
                                    (click)="confirmPasswordHide = !confirmPasswordHide">
                                    {{'visibility_off'}}
                                </mat-icon>
                                <mat-icon class="placeholder" *ngIf="!confirmPasswordHide" tooltip="Show password"
                                    (click)="confirmPasswordHide = !confirmPasswordHide">
                                    {{ 'visibility'}}
                                </mat-icon>
                            </span>
                        </div>
                    </div>
                    <div *ngFor="let validation of validation_messages.confirmpassword">
                        <div class="error-message"
                            *ngIf="f.confirmpassword.hasError(validation.type) &&  ((f.confirmpassword.dirty || f.confirmpassword.touched))">
                            {{validation.message }}
                        </div>
                    </div>
                </div>
            </div>
        </form>
        <div class="col-md-3 col-sm-3">
            <button type="submit" class="btn btn-primary submit-button"
                (click)="submit(change_password_form.value)">Submit</button>
        </div>
    </div>
    <notifier-container></notifier-container>
</app-example-wrapper-seamless>
<ngx-spinner [fullScreen]="false" size="medium" type="ball-spin-clockwise"></ngx-spinner>